<template>
  <div
    :class="{ 'input--filled': filled }"
    class="input input_style"
    :style="{ height: `calc(37px + ${inputLabelHeight}px)` }"
  >
    <label :style="{ '--input-label-height': inputLabelHeight + 'px' }">
      <input
        :id="field"
        :ref="field"
        :value="phone"
        @blur="unfocus"
        @change="updatePhone"
        @focus="focus"
        class="input__field input__field--ruri"
        type="tel"
      />
    </label>
    <div class="input__label">
      <span ref="inputLabel" class="input__label-content">{{ formattedLabel }}</span>
      <span
        class="required"
        v-if="required"
      >
        <i><img
          :src="require('@/assets/img/facebook/inf_ico.svg')"
          alt="*"
        ></i>
      </span>
    </div>
  </div>
</template>

<script>
  import 'intl-tel-input/build/css/intlTelInput.min.css'

  export default {

    name: 'PhoneInput',

    data() {
      return { inputLabelHeight: 15 }
    },

    props: {
      phone: {
        default: '',
        type: String
      },
      label: {
        default: '',
        type: String
      },
      field: {
        default: 'field',
        type: String
      },
      required: {
        default: false,
        type: Boolean
      },
      filled: {
        default: false,
        type: Boolean
      },
      locked: {
        default: false,
        type: Boolean
      },
      iti: {
        default: null,
        type: Object
      }
    },

    mounted() {
      this.$nextTick(async () => {
        let iti = await intlTelInput(this.$refs[this.field], {
          utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.0/js/utils.js',
          formatOnDisplay: true,
          preferredCountries: [this.$store.getters.country.short_name],
          initialCountry: this.$store.getters.country.short_name
        })

        this.updateITI(iti)
      })
      this.$nextTick(async () => {
        this.inputLabelHeight = this.$refs.inputLabel.clientHeight
      })
    },

    computed: {
      formattedLabel() {
        return this.label.replaceAll('<br>', '\n')
      }
    },

    methods: {
      focus() {
        this.$emit('focus')
      },
      unfocus() {
        this.$emit('unfocus')
      },
      updatePhone() {
        this.$emit('update:phone', this.iti.getNumber())
      },
      updateITI(iti) {
        this.$emit('update:iti', iti)
      }
    }

  }
</script>

<style scoped>
  .input_style input:focus {
    border-color: #0084ff;
  }

  .input__label-content {
    white-space: pre-wrap;
  }

  >>> .iti {
    top: calc(11px + var(--input-label-height)) !important;
  }
</style>
